import React from 'react';

interface Props {
  color: string;
  label: string;
}

function StatusIndicator({ color, label }: Props) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <span>{label}</span>
    </span>
  );
}

export default StatusIndicator;
